import { ReactComponent as ErrorIllustration } from '../assets/ErrorIllustration.svg';
import { Button } from '@/components/ui/button';

/**
 * Context-free fallback for the outermost ErrorBoundary (mounted outside the
 * Redux/Router/Query providers in `index.tsx`). Used for fatal errors in the
 * bootstrap/provider layer — or if the inner `ErrorPage` fallback itself throws.
 *
 * It must not depend on any app context (no hooks, no Redux/Router), so it
 * offers a plain page reload rather than the questionnaire "Recommencer".
 */
export const FatalErrorFallback = () => {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center px-4 n2xs:px-6 pb-4">
      <div className="flex flex-col items-center">
        <ErrorIllustration />
        <h1 className="text-center font-bold text-secondary text-xl mt-8">
          Oups, il y a eu un souci.
          <br />
          Nous sommes sur le coup !
        </h1>
        <p className="mt-3 text-center">Une erreur est survenue.</p>
      </div>
      <div className="pt-16">
        <Button
          variant="ctaPrimary"
          size="lg"
          onClick={() => window.location.reload()}
        >
          Rafraîchir la page
        </Button>
      </div>
    </div>
  );
};
